import { render, staticRenderFns } from "./IconIntentFriendship.vue?vue&type=template&id=38e68a2a&"
import script from "./IconIntentFriendship.vue?vue&type=script&lang=js&"
export * from "./IconIntentFriendship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports